export function DockerIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="2" y="10" width="6" height="6" stroke="currentColor" strokeWidth="2" />
      <rect x="9" y="10" width="6" height="6" stroke="currentColor" strokeWidth="2" />
      <rect x="16" y="10" width="6" height="6" stroke="currentColor" strokeWidth="2" />
      <rect x="9" y="3" width="6" height="6" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function KubernetesIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="2.4" fill="currentColor" />
      <line x1="12" y1="3" x2="12" y2="9.6" stroke="currentColor" strokeWidth="2" />
      <line x1="12" y1="14.4" x2="12" y2="21" stroke="currentColor" strokeWidth="2" />
      <line x1="4.2" y1="7.5" x2="9.9" y2="10.5" stroke="currentColor" strokeWidth="2" />
      <line x1="14.1" y1="13.5" x2="19.8" y2="16.5" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function AwsIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M7 17a4 4 0 0 1-1-7.9A5 5 0 0 1 15.5 8 4.5 4.5 0 0 1 17 17H7z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TerraformIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 20l6-16 4 10 3-6 3 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CicdIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M8 5a7 7 0 1 0 8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M8 5 6 3M8 5l1 2.5M16 5l2-2M16 5l-1 2.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MonitoringIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
      <path
        d="M6 15l3-4 3 3 3-6 3 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LinuxIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="2" y="4" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
      <path d="M6 8l4 3-4 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="14" x2="16" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function AnsibleIcon({ className = "" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="6" cy="6" r="2.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="18" cy="6" r="2.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="18" r="2.5" stroke="currentColor" strokeWidth="2" />
      <line x1="8" y1="7.5" x2="10.5" y2="16" stroke="currentColor" strokeWidth="2" />
      <line x1="16" y1="7.5" x2="13.5" y2="16" stroke="currentColor" strokeWidth="2" />
      <line x1="8.3" y1="6" x2="15.7" y2="6" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

const iconMap = {
  docker: DockerIcon,
  kubernetes: KubernetesIcon,
  aws: AwsIcon,
  terraform: TerraformIcon,
  cicd: CicdIcon,
  monitoring: MonitoringIcon,
  linux: LinuxIcon,
  ansible: AnsibleIcon,
};

export function SkillIcon({ name, className = "" }) {
  const Icon = iconMap[name] ?? DockerIcon;
  return <Icon className={className} />;
}

export function ServerRackIllustration() {
  return (
    <svg width="150" height="170" viewBox="0 0 150 170" fill="none" aria-hidden>
      <rect x="20" y="10" width="110" height="34" rx="6" fill="#F7F1E8" stroke="#141414" strokeWidth="3" />
      <circle cx="36" cy="27" r="4" fill="#141414" />
      <circle cx="50" cy="27" r="4" fill="#141414" />
      <circle cx="64" cy="27" r="4" fill="#141414" />
      <rect x="20" y="56" width="110" height="34" rx="6" fill="#F7F1E8" stroke="#141414" strokeWidth="3" />
      <circle cx="36" cy="73" r="4" fill="#141414" />
      <circle cx="50" cy="73" r="4" fill="#141414" />
      <circle cx="64" cy="73" r="4" fill="#141414" />
      <rect x="20" y="102" width="110" height="34" rx="6" fill="#F7F1E8" stroke="#141414" strokeWidth="3" />
      <circle cx="36" cy="119" r="4" fill="#141414" />
      <circle cx="50" cy="119" r="4" fill="#141414" />
      <circle cx="64" cy="119" r="4" fill="#141414" />
      <line x1="90" y1="27" x2="118" y2="27" stroke="#141414" strokeWidth="3" strokeLinecap="round" />
      <line x1="90" y1="73" x2="118" y2="73" stroke="#141414" strokeWidth="3" strokeLinecap="round" />
      <line x1="90" y1="119" x2="118" y2="119" stroke="#141414" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
